import React from 'react'
// import { Link } from 'react-router-dom'
import BGPainting from "../../assets/img/features/Prueba2.jpg"

function Take() {

    // const [yShow, setyShow] = useState()
    // const [hShow, sethShow] = useState()

  return (
    <>
         <section 
             id="video" 
             className="video-area pt-150 pb-150 p-relative" 
             style={{
                 backgroundImage: `url(${BGPainting})`, 
                 backgroundRepeat: "no-repeat", 
                 backgroundPosition: "center center", 
                 backgroundSize: "cover", // Asegura que la imagen cubra toda la pantalla
                 width: "99vw", // Ocupa todo el ancho de la ventana
                 height: "58vh", // Ocupa todo el alto de la ventana
                 opacity: 0.4 // Ajusta el nivel de transparencia
             }}
         >
                <div className="content-lines-wrapper2">
                    <div className="content-lines-inner2">
                        <div className="content-lines2"></div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default Take
